import { render } from "./ResumeSectionCredentials.vue?vue&type=template&id=11996a07"
import script from "./ResumeSectionCredentials.vue?vue&type=script&lang=js"
export * from "./ResumeSectionCredentials.vue?vue&type=script&lang=js"

import "./ResumeSectionCredentials.vue?vue&type=style&index=0&id=11996a07&lang=css"
script.render = render

export default script